import { SoundMapItem } from './sound'

export enum WalletLoadingErrorType {
  None = 'no_error',
  GenericError = 'generic_error',
  LoadingAssets = 'loading_assets',
  VersionNotSupported = 'version_not_supported'
}

export interface IWalletAssets {
  baseUrl: string
  wallets: IWalletFaceCondensed[]
}

export enum WalletFaceRarity {
  Common = 'common',
  Rare = 'rare',
  Epic = 'epic',
  Legendary = 'legendary',
  Mythic = 'mythic',
  Devine = 'devine'
}

export enum WalletFaceStatus {
  Draft = 'draft',
  Public = 'public',
  Private = 'private',
  Rejected = 'rejected'
}

export enum WalletFaceParser {
  Majblomman = 'majblomman-wallet'
}

export enum WalletFaceInterpreter {
  Blockly = 'blockly',
  Settings = 'settings',
  Sounds = 'sounds'
}

export enum WalletFaceCondition {
  NotDefined = 'not-defined',
  Purchase = 'purchase',
  Finderskeepers = 'finderskeepers',
  Retention = 'retention',
  Achievment = 'achievment'
}

export interface IWalletFaceCondition {
  type: WalletFaceCondition
  desc: string
  data: any
}

export interface IAssetResource {
  key: string
  url: string
  original?: string
  size?: number
}

export interface IWalletFaceUI {
  heroImage: string
  iconImage: string
  contactImage: string
  shopPreview?: string
}

export interface IWalletFaceInfoCopy {
  name: string
  series: string
  desc: string
}
export interface IWalletFaceInfo {
  seriesId: string
  rarity: WalletFaceRarity
  creator: string
  tags: string[]
  status: WalletFaceStatus
  created: number
  published: number
  lastModified: number
  minimumSupportedRunningBuild: number
  conditions: IWalletFaceCondition[]
  parser: WalletFaceParser
  ui: IWalletFaceUI
  copy: { [key: string]: IWalletFaceInfoCopy }
}

export interface IWalletFaceBehaviour {
  id: string
  interpreter: WalletFaceInterpreter
  data: any
}

export interface IWalletSpace {
  id: string
  key: string
  behaviours: IWalletFaceBehaviour[]
}

export interface IWalletFaceInside {
  renderPipe: string
  spaces: IWalletSpace[]
  assets: IAssetResource[]
  copy?: { [key: string]: { [key: string]: string } }
}

export interface IWalletFaceOutside {
  behaviours: IWalletFaceBehaviour[]
  assets: IAssetResource[]
  copy?: { [key: string]: { [key: string]: string } }
}

export interface IWalletFace {
  id: string
  v: number
  info: IWalletFaceInfo
  inside: IWalletFaceInside
  outside: IWalletFaceOutside
}

export interface IWalletFaceCondensed {
  id: string
  v: number
  info: IWalletFaceInfo
}

export interface IWalletFaces {
  loadWalletFace(id: string): Promise<IWalletFace>
  updateCondensedWalletFaces(): Promise<void>
  getCondensedWalletFaces(): IWalletFaceCondensed[]
  getCondensedWalletFace(id: string): IWalletFaceCondensed

  getUrl(url: string, walletId: string): string
  getWalletFace(id: string): IWalletFace

  getSupportedFaceId(id: string): string
  getInsideSettings(id: string): any
  getInsideSounds(id: string): SoundMapItem[]
  getInfoCopy(faceId: string): IWalletFaceInfoCopy | undefined
  getBaseUrl(): string
}
